import { v4 as uuidv4 } from 'uuid';
import { Injectable } from '@angular/core';
import { Options, SearchOptions, Connection, User, UserData } from 'src/app/models/server-v2';
import { OptionsV1 } from 'src/app/models/server-v1';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private options!: Options

  constructor() {
    this.load()
  }

  load() {
    let tmp: Options | undefined = (this.read('options') as Options);

    if (tmp !== undefined && tmp.widevineID === undefined) {
      tmp = undefined
      localStorage.removeItem('options')
    }

    if (tmp === undefined) {

      const wid = uuidv4()
      tmp = {
        widevineID: wid,
        // servers: [],
        users: [],
        searchOptions: {
          activeContract: true,
          noBlock: false,
          name: '',
          soloDate: false,
          orderByDeliveryDate: false
        } as SearchOptions
      } as Options

      this.write('options', tmp)
    }
    tmp.users.forEach(u => {
      if (!u.connections) {
        u.connections = [] // TODO
      }
    })

    this.options = tmp
  }

  public migrate() {

    const old: OptionsV1 | undefined = (this.read('options') as OptionsV1);


    if (old == undefined) {
      return;
    }

    if (!old.users || old.users.length === 0) {
      return
    }


    const ng: Options = {
      searchOptions: old.searchOptions,
      widevineID: old.widevineID,
      users: []
    } as Options;

    let migrated = false;

    old.users.forEach(ouser => {

      const check = ouser as any;

      if (check.id) {
        ng.users.push(check);
        return;
      }

      migrated = true;

      const newid = uuidv4();
      const nuser: User = {
        active: ouser.active,
        id: newid,
        userToken: ouser.accessToken,
        user: ouser.user,
        connections: []
      }

      if (!ouser.connections || ouser.connections.length === 0) {
        ng.users.push(nuser)
        return;
      }

      ouser.connections.forEach(oagentConn => {

        const conn: Connection = {
          active: oagentConn.active,
          agent: {
            Code: oagentConn.user.Code,
            Id: oagentConn.user.Id,
            role: oagentConn.user.role,
            Server: oagentConn.user.Server,
            exp: oagentConn.user.exp,
            name: oagentConn.user.name,
            aud: oagentConn.user.aud,
            iat: oagentConn.user.iat,
            iss: oagentConn.user.iss,
            nbf: oagentConn.user.nbf,
          },
          agentToken: oagentConn.rereshToken ?? oagentConn.accessToken,
          id: oagentConn.id,
          server: oagentConn.server,
          title: oagentConn.title,

        }

        nuser.connections.push(conn);


      })

      ng.users.push(nuser)

    })

    if (migrated) {
      this.options = ng;
      this.save();
    }




  }

  save() {
    this.write('options', this.options)
  }

  public get users(): User[] {
    if (!this.options.users) {
      this.options.users = []
    }
    return this.options.users
  }

  public set users(usersValue: User[]) {
    this.options.users = usersValue
    this.save()
  }

  public get activeUser(): User | undefined {
    if (!this.options.users) {
      return undefined
    }
    const users = this.options.users as User[]
    return users.find(x => x.active)
  }

  public setActiveUser(value: User) {
    this.options.users.forEach(x => x.active = false)
    const u = this.options.users.find(x => (value.id && x.id === value.id) || x.user.Phone === value.user.Phone && x.user.Server == value.user.Server)
    if (u) {
      u.active = true
      this.save()
    } else {
      console.error("setActiveUser: user not found")
    }
  }

  updateUser(id: string, accUser: UserData, userToken: string) {
    const u = this.options.users.find(x => x.id === id)
    if (u) {
      u.user = accUser;
      u.userToken = userToken;
      this.save()
    } else {
      console.error("updateUser: user not found")
    }
  }



  public get connections(): Connection[] {
    if (!this.options.users) {
      this.options.users = []
    }
    return this.options.users.find(x => x.active)?.connections ?? []
  }

  public set connections(value: Connection[]) {
    if (!this.options.users.find(x => x.active)?.connections)
      return
    const u = this.options.users.find(x => x.active);
    if (u) {
      u.connections = value
      this.save()
    } else {
      console.error(" set connection: user not found")
    }
  }


  public get widevineId(): string {
    return this.options.widevineID
  }

  public get searchOptions(): SearchOptions {
    if (!this.options.searchOptions) {
      this.options.searchOptions = {
        activeContract: true,
        noBlock: false,
        name: '',
        swipe: true,
        swipeSensitive: 80
      } as SearchOptions
    }
    return this.options.searchOptions
  }

  public set searchOptions(value: SearchOptions) {
    this.options.searchOptions = value
    this.save()
  }

  public deleteLocalStorage() {
    localStorage.removeItem('options')
    this.load()
    //    this.servChange.next({} as Server)
  }


  private read(key: string): unknown {
    const data = localStorage.getItem(key)
    if (data) {
      return JSON.parse(data)
    }
    return
  }

  private write(key: string, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value))
  }


}
